import Cron from "../../../app/components/CronExpression"
import React, {
    useEffect,
    useState
} from "react";

export interface CronExpressionInterface {
    field: {
        name: string,
        value: string
    },
    form: {
        touched: {},
        errors: {},
        setFieldTouched: (a: string, b: boolean) => {},
        setFieldValue: (a: string, b: string | number | Array<string | number>) => {},
        values: {}
    },
    label: string,
    hidden: boolean,
    required: boolean
}

const requiredFieldStyle = (req: boolean) => {
    return req ? <i className="fa fa-star-of-life icon-xs text-danger ms-1"></i> : null
}

export const CronExpression: React.FC<CronExpressionInterface> = ({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors, setFieldTouched, setFieldValue, values },
    label,
    hidden,
    required = false
}) => {

    const [value, setValue] = useState(field.value ? field.value.split(' ').slice(0, -1).join(' ') : '59 23 * * *');

    useEffect(() => {
        setFieldValue(field.name, value + ' *');
    }, [value]);

    return (
        <>
            {label && <label className="fw-bolder font-size-h4 label-custom mb-2" hidden={hidden}>{label}{requiredFieldStyle(required)}</label>}
            <div className="input-group">
                <Cron 
                    value={value}
                    setValue={(val: string) => {
                        setValue(val);
                    }}
                />
            </div>

        </>
    );
};